import {
  AdminFetchDocusignPartnerTemplates,
  AdminFetchLmsTrainingList,
  AdminFetchYardstikPackages,
} from 'src/constants/actionTypes'
import type {
  DocusignPartnerContractTemplate,
  LmsTrainingPlain,
  YardstikPackage,
} from 'src/interfaces/collectStepReference'
import { Action } from 'src/utils/reduxUtils'
import { CollectStepReferenceState } from './types'

function resolveApiErrorMessage(err: unknown, fallback: string): string {
  if (typeof err === 'object' && err !== null) {
    const top = err as { message?: string; payload?: { message?: string } }

    if (typeof top.payload?.message === 'string') {
      return top.payload.message
    }

    if (typeof top.message === 'string') {
      return top.message
    }
  }

  return fallback
}

const getInitialState = (): CollectStepReferenceState => ({
  partnerId: null,
  docusignTemplates: [],
  lmsTrainings: [],
  yardstikPackages: [],
  docusignLoading: false,
  lmsLoading: false,
  yardstikLoading: false,
  docusignError: null,
  lmsError: null,
  yardstikError: null,
})

export const collectStepReferenceReducer = (
  state: CollectStepReferenceState = getInitialState(),
  action: Action<unknown>,
): CollectStepReferenceState => {
  switch (action.type) {
    case AdminFetchDocusignPartnerTemplates.type.REQUEST: {
      const partnerId = (action.payload as { partnerId: string } | undefined)?.partnerId ?? null

      return {
        ...state,
        partnerId: partnerId ?? state.partnerId,
        docusignLoading: true,
        docusignError: null,
      }
    }
    case AdminFetchDocusignPartnerTemplates.type.SUCCESS:
      return {
        ...state,
        docusignTemplates: (action.payload as DocusignPartnerContractTemplate[]) ?? [],
        docusignLoading: false,
        docusignError: null,
      }
    case AdminFetchDocusignPartnerTemplates.type.FAILED:
      return {
        ...state,
        docusignLoading: false,
        docusignError: resolveApiErrorMessage(action.payload, 'Failed to load DocuSign templates'),
      }

    case AdminFetchLmsTrainingList.type.REQUEST:
      return {
        ...state,
        lmsLoading: true,
        lmsError: null,
      }
    case AdminFetchLmsTrainingList.type.SUCCESS:
      return {
        ...state,
        lmsTrainings: (action.payload as LmsTrainingPlain[]) ?? [],
        lmsLoading: false,
        lmsError: null,
      }
    case AdminFetchLmsTrainingList.type.FAILED:
      return {
        ...state,
        lmsLoading: false,
        lmsError: resolveApiErrorMessage(action.payload, 'Failed to load LMS trainings'),
      }

    case AdminFetchYardstikPackages.type.REQUEST: {
      const partnerId = (action.payload as { partnerId: string } | undefined)?.partnerId ?? null

      return {
        ...state,
        partnerId: partnerId ?? state.partnerId,
        yardstikLoading: true,
        yardstikError: null,
      }
    }
    case AdminFetchYardstikPackages.type.SUCCESS:
      return {
        ...state,
        yardstikPackages: (action.payload as YardstikPackage[]) ?? [],
        yardstikLoading: false,
        yardstikError: null,
      }
    case AdminFetchYardstikPackages.type.FAILED:
      return {
        ...state,
        yardstikLoading: false,
        yardstikError: resolveApiErrorMessage(action.payload, 'Failed to load Yardstik packages'),
      }

    default:
      return state
  }
}
